import { Component, NgZone } from '@angular/core';
import { CartRowsUpdaterService } from '../services/cart-rows-updater.service';
import { Router } from '@angular/router';

@Component({
    selector: 'cart-proceed-to-payment-button',
    templateUrl: './cart.proceed-to-payment-button.component.html',
    styleUrls: ['./../cart.component.scss']
})
export class CartProceedToPaymentButtonComponent {
    constructor(
        protected router: Router,
        protected cartRowsUpdaterService: CartRowsUpdaterService,
        protected zone: NgZone
    ) { }

    /**
     * This redirect current route to /payment.
     **/
    public proceedToPayment(): void {
        this.zone.run(() => {
            this.router.navigate(
                ['/checkout/payment'],
                {
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                }
            );
        });
    }

    /**
     * Return true or false if cart is empty.
     **/
    public canProceedToPayment(): boolean {
        return !this.cartRowsUpdaterService.isEmpty();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/cart/proceed-to-payment-button/cart.proceed-to-payment-button.component.ts